/* This file is autogenerated, see readme.md for instructions */
import ClearFillSvgIcon from '@bloomreach/banana-theme/icons/clear-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ClearFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ClearFillSvgIcon />
    </Icon>
  );
});

ClearFillIcon.displayName = 'ClearFillIcon';

export default ClearFillIcon;
